<template>
  <nav class="navbar app-navbar navbar-toggleable-md">
    <div class="navbar-brand-container d-flex align-items-center justify-content-start logo">
      <router-link class="navbar-brand" to="/dashboard">
        <img src="../../../assets/Logotipo_MasterdaWeb-01.svg" class="logo_navbar-img-svg">
      </router-link>
    </div>

    <div class="row navbar-container">
      <div
        class="menu-icon-container d-flex align-items-center justify-content-center justify-content-lg-start col"
      >
        <a
          class="menu-icon i-menu-expanded"
          href="#"
          @click.prevent="toggleSidebar(false)"
          v-if="sidebarOpened"
        ></a>
        <a class="menu-icon i-menu-collapsed" href="#" @click.prevent="toggleSidebar(true)" v-else></a>
      </div>

      <div
        class="navbar-text offset-md-1 col-md-7 d-none d-lg-flex align-items-center justify-content-center"
      >
        {{'navbar.messageUs' | translate}}&nbsp;
        <a class="open-ticket" :href="clientAreaUrl" target="_blank">{{'navbar.openTicket' | translate}}</a>
      </div>

      <div
        class="col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center"
        v-dropdown
      >
        <a
          class="nav-link dropdown-toggle d-flex align-items-center justify-content"
          href="#"
          @click.prevent="closeMenu"
        >
          <span class="i-nav-messages"></span>
        </a>
        <div class="dropdown-menu">
          <div class="dropdown-menu-content">
            <a class="dropdown-item" href="#">
              <span class="ellipsis">{{ $t('messages.new', {name: "."})}}</span>
            </a>
            <div class="dropdown-item plain-link-item">
              <a class="plain-link" href="#">{{'messages.all' | translate}}</a>
            </div>
          </div>
        </div>
      </div>
      <language-selector :options="langs"></language-selector>
      <div
        class="col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center"
        v-dropdown
      >
        <a
          class="nav-link dropdown-toggle d-flex align-items-center justify-content"
          href="#"
          @click.prevent="closeMenu"
        >
          <span class="avatar-container">
            <img :src="'https://www.gravatar.com/avatar/' + gravatar"/>
          </span>
        </a>
        <div class="dropdown-menu last">
          <div class="dropdown-menu-content">
            <div class="dropdown-item plain-link-item">
              <a class="plain-link" href="#" @click="logout()">{{'user.clientArea' | translate}}</a>
            </div>
            <div class="dropdown-item plain-link-item">
              <a class="plain-link" href="#" @click="logout()">{{'user.logout' | translate}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import LanguageSelector from './LanguageSelector'
  // import ajax from 'services/ajax'
  import configs from 'services/configs'

  export default {
    name: 'navbar',

    components: {
      LanguageSelector,
    },

    mounted() {
      /*
      ajax.run(this, 'customer/me', (data) => {
        this.gravatar = data.gravatar
      }, (error) => {
        console.log(error)
      })
      */
    },
    data() {
      return {
        clientAreaUrl: configs.CLIENT_AREA() + 'submitticket.php',
        gravatar: '',
        langs: [
          {
            code: 'br',
            name: 'portuguese'
          },
          {
            code: 'gb',
            name: 'english'
          },
        ],
        haveNotify: false
      }
    },

    computed: {
      ...mapGetters([
        'sidebarOpened',
        'toggleWithoutAnimation'
      ])
    },

    methods: {
      ...mapActions([
        'closeMenu',
        'toggleSidebar',
        'isToggleWithoutAnimation'
      ]),
      showNotify() {
        this.haveNotify = !this.haveNotify
      },
      logout() {
        localStorage.removeItem('token')
        localStorage.removeItem('X-refresh-token')
        localStorage.removeItem('region')
        localStorage.removeItem('userid')

        window.location = configs.CLIENT_AREA()
      },
    },
  }
</script>

<style lang="scss">
  @import "../../../sass/_variables.scss";
  @import "~bootstrap/scss/mixins/breakpoints";
  @import "~bootstrap/scss/functions";
  @import "~bootstrap/scss/variables";

  .action.ripple {
    color: $brand-primary;

    &:after {
      content: "\f00d";
      font-family: FontAwesome;
      font-weight: normal;
      font-style: normal;
      color: $brand-primary;
    }
  }

  .logo {
    top: 0.15rem !important;
  }

  .open-ticket, .open-ticket:hover {
    background: #4ab2e3;
    color: white;
    border-radius: 5px;
    padding: 7px;
  }

  .navbar {
    .layout-fixed & {
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 1;
    }
  }

  .navbar.app-navbar {
    .navbar-container {
      width: 100%;
      height: 100%;
      margin: 0;
    }

    height: $top-nav-height;
    padding-left: $nav-padding-left;
    padding-right: $nav-padding-right;
    background-color: $top-nav-bg;

    .avatar-container {
      display: inline-block;
      width: 50px;
      height: 50px;
      background-color: white;
      border-radius: 50%;
      border: 2px solid $lighter-gray;
      overflow: hidden;

      img {
        height: 100%;
        width: 100%;
      }
    }

    .menu-icon-container {
      padding: 0;
      font-size: $font-size-base;
    }

    .navbar-brand-container {
      position: absolute;
      z-index: 3;
      height: 100%;
      top: 0;
    }

    .nav-item {
      padding: 0;
      height: 100%;
    }

    .dropdown.navbar-dropdown {
      .dropdown-toggle {
        padding: 0;

        &:after {
          display: none;
        }
      }

      &.show {
        @include media-breakpoint-up(lg) {
          .dropdown-menu {
            left: auto;
            right: 0;
          }
        }

        &:after {
          position: absolute;
          bottom: -$dropdown-show-b;
          right: calc(50% - 10px);
          width: 0;
          height: 0;
          display: block;
          content: "";
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-bottom: 10px solid $darkest-gray;
        }
      }

      .dropdown-menu {
        margin-top: $dropdown-show-b;
        padding-top: 0;
        width: 100%;
      }

      .dropdown-item {
        height: $navbar-dd-item-height;
        cursor: pointer;
        font-size: $font-size-base;

        &:hover,
        &:active,
        &:focus,
        &.active {
          outline: none;
        }

        &.plain-link-item {
          color: $brand-primary;

          &:hover,
          &:active,
          &:focus {
            background: $dropdown-background;
          }

          .plain-link {
            text-decoration: none;
          }
        }
      }
    }

    .notify {
      position: relative;

      &::after {
        content: "";
        position: absolute;
        right: -6px;
        top: -6px;
        background-color: $brand-primary;
        height: 12px;
        width: 12px;
        border-radius: 50%;
      }
    }

    .i-nav-notification.notify::after {
      right: -4px;
      top: 0;
    }

    @include media-breakpoint-down(md) {
      height: $top-mobile-nav-height;
      padding: $nav-mobile-pt $nav-mobile-padding-h $nav-mobile-pb $nav-mobile-padding-h;

      .navbar-brand-container {
        width: $nav-mobile-brand-width;
        top: $nav-mobile-brand-top;
        left: $nav-mobile-brand-left;
        height: auto;

        .navbar-brand {
          height: $font-size-smaller;
          padding: 0;
          font-size: $font-size-smaller;
        }
      }

      .dropdown.navbar-dropdown {
        &.show {
          display: flex;

          &:after {
            bottom: -$dropdown-mobile-show-b;
            z-index: 2;
          }

          .dropdown-menu {
            margin-top: $dropdown-mobile-show-b;
            left: auto;

            &.last {
              right: 0;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/navbar/Navbar.vue